import {
  type CignaManagersResponse,
  CignaManagersResponse as CignaManagersResponseSchema,
  type CignaPrincipalsResponse,
  CignaPrincipalsResponse as CignaPrincipalsResponseSchema,
} from '@uit/shared/schemas/rcf';
import { useCallback } from 'react';
import { useApi } from '../../lib/api.js';
import { CignaManagersSection } from './CignaManagersSection.js';
import { CignaPrincipalsSection } from './CignaPrincipalsSection.js';

// Owns the shared principals + managers fetches so the two sections never go
// stale relative to each other (T-113). A principal add/remove reloads BOTH:
// the managers dropdown picks up new principals, and the manager rows pick up
// the SET-NULL of any orphaned manager.
export function RcfReferenceSections() {
  const { data: principalsResp, refetch: refetchPrincipals } = useApi<CignaPrincipalsResponse>(
    '/api/settings/cigna-principals',
    CignaPrincipalsResponseSchema,
  );
  const { data: managersResp, refetch: refetchManagers } = useApi<CignaManagersResponse>(
    '/api/settings/cigna-managers',
    CignaManagersResponseSchema,
  );

  const reload = useCallback(() => {
    void refetchPrincipals();
    void refetchManagers();
  }, [refetchPrincipals, refetchManagers]);

  const principals = principalsResp?.principals;

  return (
    <>
      <CignaPrincipalsSection principals={principals} onChange={reload} />
      <CignaManagersSection
        managers={managersResp?.managers}
        principals={principals ?? []}
        onChange={reload}
      />
    </>
  );
}
